import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiError, parseApiError } from '../../models/api-error.enum';
import type { Product } from '../../shopify/models/product.model';
import { shopifyProductService } from '../../shopify/shopify-product.service';
import { ErrorService } from '../error.service';

const errorService = new ErrorService();

export const logError = createAsyncThunk<
  string,
  string[],
  {
    rejectValue: ApiError;
  }
>('element/logError', async (messages, { rejectWithValue }) => {
  try {
    return await errorService.error(messages);
  } catch (error) {
    return rejectWithValue(parseApiError(error));
  }
});

export const loadProduct = createAsyncThunk<
  Product | null,
  void,
  {
    rejectValue: ApiError;
  }
>('element/loadProduct', async (_, { rejectWithValue }) => {
  try {
    return await shopifyProductService.lookupProduct();
  } catch (err) {
    console.error('element/loadProduct', err);
    return rejectWithValue(ApiError.Other);
  }
});
